import React, { useState } from 'react';

import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';
import { MediasProps } from '@/components/LegacyMediaContainer/types';
import Loader from '@/components/Loader';
import dynamic from '@/utils/dynamic';

import { audioStyles } from '../../styles';

const RecordedAudioPlayer = dynamic(
  () =>
    import(
      /* webpackChunkName: "recorded-audio-player" */ '@/components/Recorder/components/AudioRecorder/components/RecordedAudioPlayer'
    ),
);

function AudioPreview({
  actions,
  audioClassName,
  className,
  media,
  user,
  onAction,
}: Pick<MediasProps, 'actions' | 'audioClassName' | 'className' | 'media' | 'user' | 'onAction'>) {
  const [audioRef, setAudioRef] = useState<HTMLAudioElement | null>(null);

  return (
    <Box className={cn('group relative w-full', className)}>
      <audio ref={setAudioRef} autoPlay={false} src={media.url!} />
      <React.Suspense fallback={<Loader />}>
        <RecordedAudioPlayer
          actions={actions}
          audioRef={audioRef}
          autoPlay={false}
          className={audioClassName ?? audioStyles}
          label={user?.name}
          media={media}
          profilePicture={user?.profilePicture || undefined}
          onAction={onAction}
        />
      </React.Suspense>
    </Box>
  );
}

export default AudioPreview;
